module.exports = __webpack_public_path__ + "images/harmonie-06a366056ac9c0ff788bf624692f4a5f.jpg";